<p-dialog [(visible)]="awaitingTerminalPayment" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '380px'}">
  <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:32px 24px; text-align:center;">
    <i class="pi pi-spin pi-spinner" style="font-size:3rem; color:#2563eb;"></i>
    <div style="font-size:1.2rem; font-weight:700; color:#111827;">Waiting for Terminal</div>
    <div style="font-size:0.95rem; color:#6b7280;">Please complete the payment on the card reader.</div>
    <button pButton pRipple type="button"
      class="p-button p-button-secondary"
      style="min-width:160px;"
      (click)="cancelTerminalPayment()"><span class="p-button-icon p-button-icon-left pi pi-times" aria-hidden="true"></span><span class="p-button-label">Cancel Payment</span></button>
    </div>
  </p-dialog>

  <p-dialog [(visible)]="showTerminalBusyDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
      <div style="width:60px; height:60px; border-radius:50%; background:#fff7ed; display:flex; align-items:center; justify-content:center;">
        <i class="pi pi-exclamation-triangle" style="font-size:2rem; color:#d97706;"></i>
      </div>
      <div style="font-size:1.2rem; font-weight:700; color:#111827;">Terminal In Use</div>
      <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">This terminal is currently processing another transaction. Would you like to wait for it to finish, or clear the terminal and retry?</div>
    </div>
    <ng-template #footer>
      <div style="display:flex; justify-content:center; gap:10px; padding-bottom:8px;">
        <button pButton pRipple type="button"
          class="p-button p-button-secondary p-button-outlined"
          style="min-width:120px;"
          (click)="waitForTerminal()"><span class="p-button-icon p-button-icon-left pi pi-clock" aria-hidden="true"></span><span class="p-button-label">Wait</span></button>
          <button pButton pRipple type="button"
            class="p-button p-button-danger"
            style="min-width:150px;"
            (click)="clearTerminalAndRetryPayment()"><span class="p-button-icon p-button-icon-left pi pi-replay" aria-hidden="true"></span><span class="p-button-label">Clear Terminal</span></button>
          </div>
        </ng-template>
      </p-dialog>

      <p-dialog [(visible)]="showPaymentFailedDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
        <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
          <div style="width:60px; height:60px; border-radius:50%; background:#fef2f2; display:flex; align-items:center; justify-content:center;">
            <i class="pi pi-times-circle" style="font-size:2rem; color:#dc2626;"></i>
          </div>
          <div style="font-size:1.2rem; font-weight:700; color:#111827;">Payment Failed</div>
          <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">{{paymentFailedMessage}}</div>
        </div>
        <ng-template #footer>
          <div style="display:flex; justify-content:center; padding-bottom:8px;">
            <button pButton pRipple type="button"
              class="p-button p-button-danger"
              style="min-width:140px;"
              (click)="showPaymentFailedDialog=false; paymentButtonLocked=false;"><span class="p-button-icon p-button-icon-left pi pi-refresh" aria-hidden="true"></span><span class="p-button-label">Try Again</span></button>
            </div>
          </ng-template>
        </p-dialog>

        <p-dialog header="Deferral Reason" [(visible)]="showDeferReason" [style]="{width: '50vw', height: '50vh'}" [baseZIndex]="10000" [modal]="true">
          <div class="field mb-4 col-12">
            <div>
              <textarea pInputText type="text" style="width:100%; height: 15vw;" [(ngModel)]="deferNotes"></textarea>
            </div>
          </div>

          <ng-template #footer>
            <p-button icon="pi pi-pencil" label="Save Note" styleClass="p-button p-button-success" (click)="doReferralNote()"></p-button>
          </ng-template>

        </p-dialog>
        <div style="padding: 1rem;">
          @if (ShowTitle) {
            <h3 style="float:left;">Sell a {{MembershipOrScheduledSession}}</h3>
          }
          @if (!ViewMemberships) {
            <div style="float:right;margin-bottom:10px;">
              <button pButton type="button" class="p-button p-button-danger" style="height:40px;" (click)="returnHome()">
                <span class="pi pi-replay" style="margin-right:8px;"></span>
                <span>Start Again</span>
              </button>
            </div>
          }
          <div style="clear:both;"></div>

          @if (ViewMemberships && ListMemberships != null) {
            <div>
              <span style="font-size:18px;">Please select the {{MembershipOrScheduledSession}} you would like:</span>
              <div class="grid formgrid p-fluid" style="margin-top:20px;">
                @for (m of ListMemberships; track m) {
                  <div class="surface-card p-4 shadow-2 border-round packageCard">
                    <div id="image">
                      <img src="{{m.imageurl}}" style="width:100%">
                    </div>
                    <div style="font-weight: bold; padding: 20px;font-size:larger;">{{ m.name }}</div>
                    <div  id="dv{{m.membershiptypeid}}collapse" style="padding-left: 20px; padding-right: 20px;height:100px;" [innerHTML]="m.description != null ? (m.description.length < 100 ? m.description : (m.description.substring(0,100)) + '...') : ''">
                    </div>
                    <div id="dv{{m.membershiptypeid}}expanded" hidden="true" style="padding-left: 20px; padding-right: 20px;height:100%;" [innerHTML]="m.description">
                    </div>
                    <div style="height: 120px;">
                    </div>
                    <div style="position: absolute; bottom: 0px;width:100%;padding: 20px;text-align: right;">
                      @if (m.description.length > 99) {
                        <button pButton type="button" value="Show More..." id="dv{{m.membershiptypeid}}toggleButton" style="width:178px;" class="p-button-secondary p-button-text" (click)="toggleMore('dv'+m.membershiptypeid)">
                          <span>Show More...</span>
                        </button>
                      }
                      <div>
                        <p-button label="Select this {{MembershipOrScheduledSession}}" icon="pi pi-check" (click)="doneMembership(m)">
                        </p-button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (ViewAdmissions && MembershipAdmissions != null) {
            <div>
              <span style="font-size:18px;">Please select the Admissions from the list below:</span>
              @if (InScheduledSession && chosenScheduledSessionDates.length > 0) {
                <div class="surface-card p-4 shadow-2 border-round" style="max-width:500px; margin-top:20px;">
                  <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Session Dates</b> :
                  <div style="display:grid; grid-template-columns: 1fr 1fr; column-gap: 20px; margin-top: 10px;">
                    @for (d of chosenScheduledSessionDates; track d) {
                      <span style="margin-left: 20px; padding: 3px 0;">{{d | date:'dd/MM/yyyy HH:mm'}}</span>
                    }
                  </div>
                  <!-- <button pButton type="button" style="height: 50px; margin-top:20px;" class="p-button p-button-secondary" (click)="addScheduledSessionToCalendar()">
                  <span class="pi pi-calendar-plus" style="margin-right:8px;"></span>
                  <span>Add to Calendar</span>
                </button> -->
              </div>
            }
            <div class="grid formgrid p-fluid" style="max-width:500px;margin-top:20px;">
              <div class="field mb-4 col-12">
                @for (a of (MembershipAdmissions); track a) {
                  <div class="packageSelection clr" style="width: 400px; margin-bottom: 20px;">
                    <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                      {{a.name}}:
                    </div>
                    <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                      <p-inputnumber [(ngModel)]="SelectedAdmissions[a.index].numberofadmissions!" [id]="'ad'+a.name" [showButtons]="true" max="{{a.max}}" min="{{a.min}}" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                    </div>
                  </div>
                }
                <div style="clear:both;">
                  @if (!admissionsMaxReached) {
                    <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button" (click)="doneAdmissions()">
                      <span>Continue</span>
                      <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }

        @if (ViewDetails && MembershipAdmissions != null) {
          <div>
            <span style="font-size:18px;">Please specify the details for each member:</span>
            <div class="grid formgrid p-fluid" style="max-width:500px;margin-top:20px;">
              <div class="field mb-4 col-12">
                @for (a of (DetailedMembershipAdmissions); track a) {
                  <div class="packageSelection clr">
                    <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                      <div style="font-weight:bold; font-size:18px; margin-bottom:5px;margin-top:5px;">
                        {{a.name + " - " + a.admissionsindex}}:
                      </div>
                      <div class="field mb-4 col-12">
                        <label for="classname" class="font-medium">Name</label>
                        <input [(ngModel)]="a.membername" (ngModelChange)="nameChanged(a)" id="classname" type="text" pInputText>
                        @if (validname[a.index - 1]) {
                          <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a a name.</div>
                        }
                      </div>
                      @if (a.detailsrequired) {
                        <div class="field mb-4 col-12">
                          <label for="classname" class="font-medium">Date of Birth</label>
                          <p-datepicker [selectOtherMonths]="true" [(ngModel)]="a.memberdob" (ngModelChange)="dobChanged(a)" [utc]="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" [maxDate]="maxDOB" [defaultDate]="maxDOB" inputId="packagestartdate"></p-datepicker>
                          @if (validdob[a.index - 1] && a.detailsrequired) {
                            <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a a date of birth.</div>
                          }
                          @if (validdobinpast[a.index - 1] && a.detailsrequired) {
                            <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>The date of birth must be before today.</div>
                          }
                        </div>
                      }
                    </div>
                    <hr style="border: lightgray 1px solid;">
                    @if (a.questionnaire != null && a.questionnaire.bookingquestions != null && a.questionnaire.bookingquestions.length > 0) {
                      <div>
                        @for (bq of a.questionnaire.bookingquestions; track bq) {
                          <div class="field mb-4 col-12">
                            @if (bq.questiontype=='AGE' && bq.answers != null) {
                              <div class="p-fluid">
                                <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label><br>
                                <p-inputnumber Style="margin-top:10px;" [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.ageanswer" min="{{bq.minage}}" max="{{bq.maxage}}" spinnerMode="horizontal"></p-inputnumber>
                                @if (!bq.answers.mustanswerage) {
                                  <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide age details.</div>
                                }
                                <hr style="margin-bottom:0px;margin-top:20px;border: lightgray 1px solid;">
                              </div>
                            }
                            @if (bq.questiontype=='FREETEXT' && bq.answers != null) {
                              <div class="p-fluid">
                                <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                <br>
                                  <input id="bq{{bq.id}}" type="text" style="margin-top:10px;" [(ngModel)]="bq.answers.freetextanswer" pInputText>
                                  @if (!bq.answers.mustanswerfreetext) {
                                    <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question</div>
                                  }
                                  <hr style="margin-bottom:0px;margin-top:20px;border: lightgray 1px solid;">
                                </div>
                              }
                              @if (bq.questiontype=='ALLERGY' && bq.answers != null) {
                                <div>
                                  <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                  <br>
                                    <p-selectbutton id="allergy" [style]="{'width' : '100%', 'margin-top' : '10px'}" [options]="stateOptionAllergy" [(ngModel)]="bq.answers.allergyanswer.allergypresent"></p-selectbutton>
                                    @if (bq.answers.allergyanswer.allergypresent == null) {
                                      <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer whether an allergy is present or not</div>
                                    }
                                    @if (bq.answers.allergyanswer.allergypresent==true) {
                                      <div class="p-fluid">
                                        <label for="bq{{bq.id}}" style="margin-top:20px;" class="font-medium">Please specify allergy details below</label>
                                        <br>
                                          <input id="bq{{bq.id}}" type="text" [(ngModel)]="bq.answers.allergyanswer.allergytext" pInputText>
                                        </div>
                                      }
                                      @if (!bq.answers.mustanswerallergies && bq.answers.allergyanswer.allergypresent==true) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide allergy details</div>
                                      }
                                      <hr style="margin-bottom:0px;margin-top:20px;border: lightgray 1px solid;">
                                    </div>
                                  }
                                  @if (bq.questiontype=='MULTICHOICESINGLE' && bq.answers != null) {
                                    <div class="p-fluid">
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <div style="margin-top:10px;">
                                        <p-select [options]="bq.listitems" placeholder="Please select an option" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicesingleanswer"></p-select>
                                      </div>
                                      @if (!bq.answers.mustanswermultichoicesingleanswer) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose an item</div>
                                      }
                                      <hr style="margin-bottom:0px;margin-top:20px;border: lightgray 1px solid;">
                                    </div>
                                  }
                                  @if (bq.questiontype=='MULTICHOICEMULTIPLE' && bq.answers != null) {
                                    <div class="p-fluid">
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <div style="margin-top:10px;">
                                        <p-multiselect [options]="bq.listitems" placeholder="Please select one or more options" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicemultianswer"></p-multiselect>
                                      </div>
                                      @if (!bq.answers.mustanswermultichoicemultianswer) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose one or more items</div>
                                      }
                                      <hr style="margin-bottom:0px;margin-top:20px;border: lightgray 1px solid;">
                                    </div>
                                  }
                                  @if (bq.questiontype=='DATE' && bq.answers != null) {
                                    <div class="p-fluid">
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <br>
                                        <p-datepicker Style="display:block; margin-top:10px;" [selectOtherMonths]="true" [firstDayOfWeek]="firstDayOfWeek" [(ngModel)]="bq.answers.dateanswer" dateFormat="dd/mm/yy" [showIcon]="true"></p-datepicker>
                                        @if (!bq.answers.mustanswerdate) {
                                          <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a date</div>
                                        }
                                        <hr style="margin-bottom:0px;margin-top:20px;border: lightgray 1px solid;">
                                      </div>
                                    }
                                    @if (bq.questiontype=='NUMBER' && bq.answers != null) {
                                      <div class="p-fluid">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <br>
                                          <p-inputnumber Style="margin-top:10px;" [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.numberanswer" spinnerMode="horizontal"></p-inputnumber>
                                          @if (!bq.answers.mustanswernumber) {
                                            <div class="text-danger" Style="margin-left:10px;margin-top:10px;color:red;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a number</div>
                                          }
                                          <hr style="margin-bottom:0px;margin-top:20px;border: lightgray 1px solid;">
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          <div style="clear:both;">
                            @if (admissionsMaxReached) {
                              <div class="text-danger" Style="margin-left:10px;margin-bottom:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>{{admissionsMaxReachedMessage}}</div>
                            }
                            @if (!admissionsMaxReached) {
                              <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button" (click)="doneDetails()">
                                <span>Continue</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                              </button>
                            }
                            @if (admissionsMaxReached) {
                              <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button-danger" (click)="returnHome()">
                                <span class="pi pi-replay" style="margin-right:8px;"></span>
                                <span>Start Again</span>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  @if (ViewCustomer && MembershipAdmissions != null) {
                    <div>
                      <span style="font-size:18px;">Please enter the customer details:</span>
                      <div class="grid formgrid p-fluid"  style="margin-top:20px;">
                        <div class="field mb-4 col-12">
                          <div style="margin-bottom: 40px;">
                            <span class="p-input-icon-left ml-auto" style="margin-right:20px; float:left; width:240px;">
                              <i class="pi pi-search"></i>
                              <input pInputText type="text" [(ngModel)]="searchCriteria" buttonLayout="horizontal" placeholder="Lastname/Mobile/Email" style="height: 50px;padding-left:33px;width:250px;" />
                            </span>
                            <button pButton type="button" style="float:left;height: 50px; width:150px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="searchCustomer()">
                              <span class="pi pi-search" style="margin-right:8px;"></span>
                              <span i18>Search</span>
                            </button>
                            <div style="clear:both;"></div>
                            @if (customersResult) {
                              <div style="margin-top:20px;" class="surface-card p-4 shadow-2 border-round">
                                <p-table [value]="customersResult.data">
                                  <ng-template #header>
                                    <tr style="color:Black;background-color:White;font-weight:bold;">
                                      <th scope="col">Name</th>
                                      <!-- <th scope="col">Address</th> -->
                                      <th scope="col">Mobile</th>
                                      <th scope="col">Email Address</th>
                                      <th width="5%">&nbsp;</th>
                                      <th width="5%">&nbsp;</th>
                                    </tr>
                                  </ng-template>
                                  <ng-template #body let-data>
                                    <tr (click)="addselectedCustomer(data)" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" style="background-color: rgb(255, 255, 255); cursor: pointer;">
                                      <td>{{data.fullName}}</td>
                                      <!-- <td>{{data.address1}}</td> -->
                                      <td>{{data.mobile}}</td>
                                      <td>{{data.email}}</td>
                                      <!--<td>
                                      <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="addselectedCustomer(data)">
                                        <span class="pi pi-check" style="margin-right:8px;"></span>
                                      Select</button>
                                    </td>-->
                                    <td>
                                      <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="applyCustomer(data)">
                                        <span class="pi pi-pencil" style="margin-right:8px;"></span>
                                      Edit</button>
                                    </td>
                                  </tr>
                                </ng-template>
                              </p-table>
                              @if (customersResult) {
                                <button style="margin-top:15px;" pButton pRipple type="button" class="p-button p-element p-button-success" (click)="addCustomer()" style="max-width: 400px;margin-top: 20px;">
                                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                                Add Customer</button>
                              }
                            </div>
                          }
                        </div>
                        @if (ShowCustomerDetails) {
                          <div class="surface-card p-4 shadow-2 border-round">
                            <div class="grid formgrid p-fluid">
                              @if (IsToday()) {
                                <div class="field mb-4 col-12">
                                  <p-selectbutton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptions" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectbutton>
                                </div>
                              }
                              @if (!IsToday()) {
                                <div class="field mb-4 col-12">
                                  <p-selectbutton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptionsMin" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectbutton>
                                </div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED') {
                                <div class="field mb-4 col-12" >
                                  <label for="firstName" class="font-medium">First Name</label>
                                  <input id="firstName" type="text" [(ngModel)]="firstName" pInputText autocomplete="given-name">
                                </div>
                              }
                              @if (!firstNameValid) {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a first name.</div>
                              }
                              <div class="field mb-4 col-12">
                                <label for="lastname" class="font-medium">Last Name</label>
                                <input id="lastname" type="text" [(ngModel)]="lastName" pInputText autocomplete="family-name">
                              </div>
                              @if (!lastNameValid) {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="address1" class="font-medium">Address 1</label>
                                  <input id="address1" type="text" [(ngModel)]="address1" pInputText autocomplete="address-line1">
                                </div>
                              }
                              @if (!Address1Valid && ProvideMinimalPersonalData == 'FULL') {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an address.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="address2" class="font-medium">Address 2</label>
                                  <input id="address2" type="text" [(ngModel)]="address2" pInputText autocomplete="address-line2">
                                </div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="town" class="font-medium">Town / City</label>
                                  <input id="town" type="text" [(ngModel)]="town" pInputText autocomplete="address-line3">
                                </div>
                              }
                              @if (!TownValid && ProvideMinimalPersonalData == 'FULL') {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a town/city.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="postcode" class="font-medium">Post Code</label>
                                  <input id="postcode" type="text" [(ngModel)]="postCode" pInputText autocomplete="postal-code">
                                </div>
                              }
                              @if (!PostCodeValid && ProvideMinimalPersonalData == 'FULL') {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a postcode.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED') {
                                <div style="width:100%">
                                  <div class="field mb-4 col-12">
                                    <label for="email" class="font-medium">Email</label>
                                    <input id="email" type="email" [(ngModel)]="email" pInputText autocomplete="email">
                                  </div>
                                  @if (!EmailValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                                  }
                                  @if (!EmailFormatValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>
                                  }
                                </div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED') {
                                <div style="width:100%">
                                  <div class="field mb-4 col-12">
                                    <label for="mobile" class="font-medium">Mobile</label>
                                    <input id="mobile" type="tel" pattern="^(\+44\s?|0)7\d{9}$" [(ngModel)]="mobile" pInputText autocomplete="mobile">
                                  </div>
                                  @if (!MobileValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a mobile number.</div>
                                  }
                                  @if (!MobileFormatValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid mobile number.<div style="clear:both;"></div></div>
                                  }
                                </div>
                              }
                              <div style="clear:both;width: 100%;height: 20px;"></div>
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneCustomer()">
                                <span>Add this Customer</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }

                @if (ViewPayment && MembershipAdmissions != null) {
                  <div>
                    <span style="font-size:18px">Please specify payment details:</span>
                    <div class="grid formgrid p-fluid" style="margin-top:20px;">
                      <div class="field mb-4 col-12">
                        <div class="surface-card p-4 shadow-2 border-round">
                          <div class="grid formgrid p-fluid">
                            <div style="font-weight:bold; font-size:20px; margin-bottom:20px;">
                              @if (saleHasAdjustments) {
                                <span>Value of {{MembershipOrScheduledSession}}: {{(saleValueBeforeAdjustments) | currency:CurrencySymbol}} </span>
                              }
                              @if (thisMembershipSale?.totaldiscounts > 0) {
                                <span>(- Discount: {{thisMembershipSale.totaldiscounts | currency:CurrencySymbol}}) </span>
                              }
                              @if (thisMembershipSale?.totalbookingfees > 0) {
                                <span>(+ Booking Fee: {{thisMembershipSale.totalbookingfees | currency:CurrencySymbol}}) </span>
                              }
                              Total Value: {{(Total) | currency:CurrencySymbol}}
                            </div>
                            <div class="field mb-4 col-12">
                              <label for="venueclosingname" class="font-medium">Payment Value</label>
                              <p-inputnumber [(ngModel)]="Total" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputnumber>
                            </div>
                            @if (!paymentValueValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a payment amount.</div>
                            }
                            @if (!paymentValueExceededValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You cannot pay more than the booking value.</div>
                            }
                            @if (!paymentDepositValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your payment must be at least {{MinimumValidPayment | currency:CurrencySymbol}}.</div>
                            }
                          </div>
                          @if (showDiscount) {
                            <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                              <div class="field mb-4 col-12">
                                <p-selectbutton id="openDiscount" [style]="{'width': '100%', 'max-width' : '430px', 'margin-bottom' : '20px'}" [options]="stateOptionOpenDiscount" [(ngModel)]="openDiscount"></p-selectbutton>
                                @if (openDiscount) {
                                  <div>
                                    <label for="discountCode" class="font-medium">Enter Discount Amount</label><br>
                                    <p-inputnumber [(ngModel)]="chosenDiscountAmount" max="{{validPaymentAmount}}" min="0.01"  mode="currency" currency={{CurrencySymbol}} ></p-inputnumber>
                                  </div>
                                }
                                @if (!openDiscount) {
                                  <div>
                                    <label for="discountCode" class="font-medium">Enter Discount Code</label><br>
                                    <input id="discountCode" [(ngModel)]="discountCode" pInputText>
                                  </div>
                                }
                              </div>
                              @if (openDiscount) {
                                <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneOpenDiscount()">
                                  <span>Apply Discount</span>
                                  <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button>
                              }
                              @if (!openDiscount) {
                                <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneDiscount()">
                                  <span>Apply Discount</span>
                                  <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button>
                              }
                            </div>
                          }
                          @if (showVoucher) {
                            <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                              <div class="field mb-4 col-12" style="float:left;">
                                <label for="voucherCode" class="font-medium">Enter Gift Voucher</label><br>
                                <input id="voucherCode" [(ngModel)]="voucherCode" pInputText>
                                <br>
                                  <label for="voucherPIN" class="font-medium">Enter PIN</label><br>
                                  <input id="voucherPIN" [(ngModel)]="voucherpin" pInputText [maxlength]="4" type="password">
                                  <div style="clear:both; width:100%"></div>
                                </div>
                                <div>
                                  <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneVoucher()">
                                    <span>Apply</span>
                                  </button>
                                </div>
                                <div style="clear:both; width:100%"></div>
                              </div>
                            }
                            @for (p of PaymentTypes; track p) {
                              <button [disabled]="paymentButtonLocked" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button" (click)="donePayment(p.id, p.name)">
                                @if (p.name=='Cash' && CurrencySymbol=='GBP') {
                                  <span class="pi pi-pound" style="margin-right:8px;"></span>
                                }
                                @if (p.name=='Cash' && CurrencySymbol=='USD') {
                                  <span class="pi pi-dollar" style="margin-right:8px;"></span>
                                }
                                @if (p.name=='Cash' && CurrencySymbol=='EUR') {
                                  <span class="pi pi-euro" style="margin-right:8px;"></span>
                                }
                                @if (p.name=='Cash' && CurrencySymbol=='AUD') {
                                  <span class="pi pi-dollar" style="margin-right:8px;"></span>
                                }
                                @if (p.name=='Card') {
                                  <span class="pi pi-credit-card" style="margin-right:8px;"></span>
                                }
                                @if (p.name!='Cash' && p.name!='Card') {
                                  <span class="pi pi-money-bill" style="margin-right:8px;"></span>
                                }
                                <span>Pay With {{p.name}}</span>
                              </button>
                            }
                            @if (!showDiscount) {
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayDiscount()">
                                <span class="pi pi-arrow-circle-down" style="margin-right:8px;"></span>
                                <span>Enter Discount</span>
                              </button>
                            }
                            @if (showDiscount) {
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayDiscount()">
                                <span class="pi pi-arrow-circle-left" style="margin-right:8px;"></span>
                                <span>Hide Discount</span>
                              </button>
                            }
                            @if (thisMembershipSale.discounts) {
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-danger" (click)="removeDiscount()">
                                <span class="pi pi-arrow-circle-up" style="margin-right:8px;"></span>
                                <span>Remove Discount</span>
                              </button>
                            }
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-danger" (click)="deferPayment()">
                              <span class="pi pi-clock" style="margin-right:8px;"></span>
                              <span>Defer Payment</span>
                            </button>
                            <!-- Parked until the API can issue a payment link for a membership sale.
                            <br>
                              <button *ngIf="!showDiscount" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-warn" (click)="sendPaymentLink()">
                                <span class="pi pi-envelope" style="margin-right:8px;"></span>
                                <span>Send Payment Link</span>
                              </button>
                              -->
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                    @if (MembershipComplete) {
                      <div>
                        <div class="p-3 flex flex-column flex-auto">
                          <h3 style="margin-bottom: 44px; margin-top: -23px; margin-left: -17px;" i18n>{{MembershipOrScheduledSession}} Summary</h3>
                          <div>
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-users" style="margin-right: 10px;"></span><b>{{MembershipOrScheduledSession}}p ID : {{membershipSummary.membershipidhr}}</b>
                            </div>
                            @if (MembershipOrScheduledSession == 'Membership') {
                              <div style="width:100%; margin-bottom: 15px;">
                                <span class="pi pi-th-large" style="margin-right: 10px;"></span><b>PIN : {{membershipSummary.PIN}}</b>
                              </div>
                            }
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-clone" style="margin-right: 10px;"></span><b>{{MembershipOrScheduledSession}} Type</b> : {{membershipSummary.membershipType}}
                            </div>
                            @if (MembershipOrScheduledSession == 'Membership') {
                              <div style="width:100%; margin-bottom: 15px;">
                                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Start Date</b> : {{membershipSummary.startTime | date:'dd/MM/yyyy'}}
                              </div>
                            }
                            @if (MembershipOrScheduledSession == 'Membership') {
                              <div style="width:100%; margin-bottom: 15px;">
                                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>End Date</b> : {{membershipSummary.endTime | date:'dd/MM/yyyy'}}
                              </div>
                            }
                            @if (MembershipOrScheduledSession != 'Membership') {
                              <div style="width:100%; margin-bottom: 15px;">
                                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Session Dates</b> : <br>
                                @for (d of membershipSummary.scheduleddates; track d) {
                                  <span style="margin-left: 20px;">{{d | date:'dd/MM/yyyy HH:mm'}}<br></span>
                                }
                              </div>
                            }
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-bars" style="margin-right: 10px;"></span><b>{{MembershipOrScheduledSession}} Details</b> : {{membershipSummary.admissions}}
                            </div>
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-user" style="margin-right: 10px;"></span><b>Customer Name</b> : {{membershipSummary.customerName}}
                            </div>
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-home" style="margin-right: 10px;"></span><b>Customer Address</b> : {{membershipSummary.customerAddress}}
                            </div>
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-mobile" style="margin-right: 10px;"></span><b>Customer Mobile</b> : {{membershipSummary.customerMobile}}
                            </div>
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-envelope" style="margin-right: 10px;"></span><b>Customer Email</b> : {{membershipSummary.customerEmail}}
                            </div>
                            <div style="width:100%; margin-bottom: 15px;">
                              <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Paid</b> : {{membershipSummary.paid | currency:CurrencySymbol}}
                            </div>
                            @if (membershipSummary.deferrednote) {
                              <div style="width:100%; margin-top:20px; padding-top:15px; border-top:1px solid #e5e7eb;">
                                <span class="pi pi-clock" style="margin-right: 10px;"></span><b>Deferred Payment Note</b> : {{membershipSummary.deferrednote}}
                              </div>
                            }
                            <div style="margin-top:25px;">
                              <b>These {{MembershipOrScheduledSession}} details have been sent to the customer.</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                  </div>